import * as z from 'zod';

// It is important these schemas are passthrough (I don't like we have that implicit assumption) to avoid
// overwriting uiSettings with wrong values
export const defaultThemeSchema = z
  .object({
    // if no theme set, 'dark' is default, if theme is anything else, catch with 'dark'
    theme: z.enum(['dark', 'white']).optional().catch('dark'),
  })
  // keep everything else
  .passthrough()
  // if parsing fails on this level that means UI settings is some garbage so default to the minimum required
  // subobject with defaults
  .catch({ theme: 'dark' });

export const primaryColorSchema = z
  .object({
    branding: z
      .object({
        colors: z
          .object({
            primary: z.string().optional().nullable().catch(null),
          })
          .passthrough()
          .optional()
          .catch({}),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const fontFamilySchema = z
  .object({
    branding: z
      .object({
        font: z.string().optional().nullable().catch(null),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const customLoaderSchema = z
  .object({
    branding: z
      .object({
        loader: z.string().optional().nullable().catch(null),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const displayRossumBrandingSchema = z
  .object({
    branding: z
      .object({
        powered_by: z.boolean().optional().catch(true),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const displayAuroraBrandingSchema = z
  .object({
    branding: z
      .object({
        powered_by_aurora: z.boolean().optional().catch(true),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const customLogoImageSchema = z
  .object({
    branding: z
      .object({
        top_left: z.string().optional().nullable().catch(null),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const customBrandNameSchema = z
  .object({
    branding: z
      .object({
        brand_name: z.string().optional().nullable().catch(null),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const customUserAvatarImageSchema = z
  .object({
    branding: z
      .object({
        top_right: z.string().optional().nullable().catch(null),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const showExternalResourcesSchema = z
  .object({
    branding: z
      .object({
        hide_article_links: z.boolean().optional().catch(false),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

export const squareSchema = z
  .object({
    branding: z
      .object({
        border_radiuses: z.record(z.string(), z.number()).optional().catch({}),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});

const supportMenuItemSchema = z.object({
  type: z.literal('link'),
  label: z.string(),
  url: z.string(),
});

export const supportMenuSchema = z
  .object({
    branding: z
      .object({
        support_menu: z
          .array(supportMenuItemSchema)
          .optional()
          .nullable()
          .catch(null),
      })
      .passthrough()
      .optional()
      .catch({}),
  })
  .passthrough()
  .catch({});
